import React from 'react';
import { observer } from 'mobx-react';
import ConfirmSuccessComponent from './Confirm-success.component';
import useConfirmSuccess from './useConfirmSuccess';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';

const Container = ({ onClose }: ICloseEvent) => {
    const { store, lang } = useConfirmSuccess(onClose);

    return (
        <>
            <ConfirmSuccessComponent
                lang={lang.lang}
                confirmed={store.confirmed}
                passwordConfirmed={store.passwordConfirmed}
                confirmationErr={store.confirmationErr}
                onClose={onClose}
            />
        </>
    );
};

const ConfirmSuccessContainer = observer(Container);

export default ConfirmSuccessContainer;
